// Note: Keep enum values exactly as per spec!
const DEVICE_TYPE = {
  VIDEO: "videoInput",
  AUDIO: "audioInput"
};

const OPENTOK_AUDIO_UPDATED_EVENT = "audioLevelUpdated";

const TEST_RESULT = {
  EXCELLENT: "EXCELLENT",
  GOOD: "GOOD",
  OK: "OK",
  POOR: "POOR",
  BAD: "BAD",
  ERROR: "ERROR",
  READY: "READY"
};

const MOS_RESULT_MAP = {
  5: TEST_RESULT.EXCELLENT,
  4: TEST_RESULT.GOOD,
  3: TEST_RESULT.OK,
  2: TEST_RESULT.POOR,
  1: TEST_RESULT.BAD,
  0: TEST_RESULT.ERROR
};

export { DEVICE_TYPE, OPENTOK_AUDIO_UPDATED_EVENT, TEST_RESULT, MOS_RESULT_MAP };
